import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../../ts/ServerApi/types/actionParams';

export interface IRunExtractRefreshesOnWorkbooksParams extends IMultipleIdsParams {
  type: string; // ExtractTaskType
}

export class RunExtractRefreshesOnWorkbooksRequest extends Request<IRunExtractRefreshesOnWorkbooksParams, IResult> {
                          // type must be from ExtractTaskType
  constructor(ids: string[], type: string) {
    super('runExtractRefreshesOnWorkbooks', {
      ids: ids,
      type: type
    });
  }
}
